<template>
  <slot
    v-if="$slots.item"
    name="item"
    v-bind="{ item }"
  />
  <Button
    v-else
    v-bind="{
      [item.to ? 'to' : 'href']: item.to || item.url || '#',
    }"
    as="router-link"
    text
    class="w-full"
    :class="{
      '!bg-primary-100 dark:text-primary-900 dark:hover:!text-primary-900 font-bold': route.fullPath.includes(item.to),
    }"
    :pt="{
      root: '!justify-start',
    }"
  >
    <UiLucideIcon
      v-if="item.icon"
      :icon="item.icon"
    />
    <span>{{ item.label }}</span>
    <UiLucideIcon
      v-if="item.items"
      :icon="ChevronDown"
    />
    <Badge
      v-if="item.badge"
      :value="item.badge"
    />
  </Button>
</template>

<script lang="ts" setup>
import { ChevronDown } from 'lucide-vue-next'
import UiLucideIcon from '~/components/ui/LucideIcon.vue'

defineProps({
  item: { type: Object, required: true },
})

const route = useRoute()
</script>
